import { FilterFormLabels, FilterFormValues, Sorting } from './types';

export const defaultFormValues: FilterFormValues = {
    destination: [],
    theme: [],
    startDate: undefined,
    endDate: undefined,
    flexibility: 0,
    // adults: '0',
    // children: '0',
    // childrenAges: [],
    nbPax: '0',
    // secondary
    levels: [],
    types: [],
    durationMin: 1,
    durationMax: 40,
    budgetMin: 0,
    budgetMax: 20000,
    tags: [],
};

export const defaultFormLabels: FilterFormLabels = {
    destination: [],
    theme: [],
    startDate: undefined,
    endDate: undefined,
    nbPax: '',
    // secondary
    levels: '',
    types: '',
    duration: '',
    budget: '',
    tags: '',
};

export const sortingEntries = [
    { value: Sorting.DEFAULT, label: 'Recommandation' },
    { value: Sorting.PRICE_ASC, label: 'Prix croissant' },
    { value: Sorting.PRICE_DESC, label: 'Prix décroissant' },
    { value: Sorting.DURATION_ASC, label: 'Durée croissante' },
    { value: Sorting.DURATION_DESC, label: 'Durée décroissante' },
    { value: Sorting.REVIEWS_DESC, label: 'Avis' },
    { value: Sorting.DEPARTURE_DATE, label: 'Date de départ' },
];
